import "./Partners.scss";

import { useTranslation } from "react-i18next";

import Contact from "../../components/Contact/Contact";
import Separator from "../../components/Separator/Separator";
import getImageUrl from "../../Utils/Services/img/imgFetch";

const partners = [
  {
    name: "Fondation Roi Baudouin",
    logo: "partners/kbs-frb.PNG",
    link: "https://www.kbs-frb.be/",
  },
];

const ownersOf4x4 = [
  {
    name: "Anatole asbl",
    address: "Forêt de Soignes",
    phone: "0497/300.612",
    email: null,
    image: "partners/anatole.jpg",
  },
  {
    name: "L'Essentiel",
    address: "Chaussée de Louvain 563, 1380 Lasne",
    phone: null,
    email: null,
    image: "partners/essentiel.png",
  },
  {
    name: "CAVALC'ANE",
    address: "Rue fond du bois 30, 5651 Laneffe",
    phone: "0477/73.30.38",
    email: "cavalcane.4x4@gmail.com",
    image: null,
  },
];

const Partners = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="partnersSection">
        <h1>{t("partners.title")}</h1>
        <p>{t("partners.intro")}</p>

        <h2>{t("partners.mainPartnersTitle")}</h2>
        <div className="partnersGrid">
          {partners.map((partner, index) => (
            <a
              key={index}
              href={partner.link}
              target="_blank"
              rel="noopener noreferrer"
              className="partnerCard"
            >
              <img
                src={getImageUrl(partner.logo)}
                alt={partner.name}
                className="partnerLogo"
              />
              <h3>{partner.name}</h3>
            </a>
          ))}
        </div>

        <h2>{t("partners.ownersTitle")}</h2>
        <div className="ownersGrid">
          {ownersOf4x4.map((owner, index) => (
            <div key={index} className="partnerCard">
              {owner.image && (
                <img
                  src={getImageUrl(owner.image)}
                  alt={owner.name}
                  className="ownerLogo"
                />
              )}
              <h3>{owner.name}</h3>
              <p>{owner.address}</p>
              {owner.phone && (
                <p>
                  <a href={`tel:${owner.phone}`}>{owner.phone}</a>
                </p>
              )}
              {owner.email && (
                <p>
                  <a href={`mailto:${owner.email}`}>{owner.email}</a>
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
      <Separator />
      <Contact />
    </>
  );
};

export default Partners;
